module.exports = __webpack_public_path__ + "static/media/ico_capacitacion.cf1a3299.png";